<p-card class="sameSizeCards container" [ngClass]="{'taskComplete': workOrderWellnessTask.wellnessTask.completionStatus == 'Completed' || workOrderWellnessTask.wellnessTask.completionStatus =='Unable to be Completed' }">
  <div class="row" [class.highlightDay]="workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
      && workOrderWellnessTask.wellnessTask.completionStatus != 'Unable to be Completed'
      &&  isCurrentDate"
    >
    @if (showStatusBar) {
    <div class="status-header col-12 row" [ngClass]="{
        'completed': workOrderWellnessTask.wellnessTask.completionStatus == 'Completed' || workOrderWellnessTask.wellnessTask.completionStatus == 'Unable to be Completed',
        'go-back': workOrderWellnessTask.wellnessTask.completionStatus == 'Go Back' || isIncompleteGoBack,
        'rm-follow-up': workOrderWellnessTask.wellnessTask.completionStatus == 'Customer Unsatisfied - RM Follow Up'
      }">
        <div class="status-bar col-12 container">
          <i style="vertical-align: middle;" class="fa" [ngClass]="{
            'fa-check': workOrderWellnessTask.wellnessTask.completionStatus == 'Completed',
            'fa-exclamation': workOrderWellnessTask.wellnessTask.completionStatus == 'Customer Unsatisfied - RM Follow Up',
            'fa-arrow-left': workOrderWellnessTask.wellnessTask.completionStatus == 'Go Back'
            }">
          </i>
          <span style="vertical-align: middle;">&nbsp;{{workOrderWellnessTask.wellnessTask.completionStatus == 'Unable to be Completed' ? 'Cancelled' : workOrderWellnessTask.wellnessTask.completionStatus}}</span>
          @if (workOrderWellnessTask.wellnessTask.paymentStatus) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;{{workOrderWellnessTask.wellnessTask.paymentStatus}}</span>
          }
          @if (workOrderWellnessTask.wellnessTask.paidDate) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;{{workOrderWellnessTask.wellnessTask.paidDate | date: 'shortDate'}}</span>
          }
          @if (!workOrderWellnessTask.wellnessTask.paymentStatus) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;Not Paid</span>
          }
          @if (!workOrderWellnessTask.wellnessTask.paidDate) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;No paid date</span>
          }
        </div>
        <br/>
        @if (workOrderWellnessTask.wellnessTask.customerIssue && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed') {
          <div class="col-12 showLineBreaks">
            {{workOrderWellnessTask.wellnessTask.customerIssue}}
          </div>
        }
        @if (workOrderWellnessTask.wellnessTask.wellnessTaskGoBackEquipment && workOrderWellnessTask.wellnessTask.wellnessTaskGoBackEquipment.length > 0 && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed') {
          <div class="col-4">
            Required Equipment Type(s):
          </div>
        }
        @if (workOrderWellnessTask.wellnessTask.wellnessTaskGoBackEquipment && workOrderWellnessTask.wellnessTask.wellnessTaskGoBackEquipment.length > 0 && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed') {
          <div class="col-8">
            @for (wtEquipment of workOrderWellnessTask.wellnessTask.wellnessTaskGoBackEquipment; track wtEquipment) {
              <span class="taskStyle">
                {{wtEquipment.equipmentType.type}}
              </span>
            }
          </div>
        }
        @if (isIncompleteGoBack) {
          <div class="col-4">
            <label>Go Back Uploads:</label>
          </div>
        }
        @if (isIncompleteGoBack) {
          <div class="col-8">
            <app-blob-manager [angularUpload]="true"
              [containerName]="'wellness-task-go-back'"
              [parentRecordId]="uploadId"
              [uploadLabel]="'Document/Photo'"
            [viewOnly]="true"></app-blob-manager>
          </div>
        }
        <div class="col-12" style="text-align: left">
          @if (canComplete
            && (workOrderWellnessTask.wellnessTask.goBackBucketId != undefined)
            && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
            && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
            <p-button              
              type="button"
              label="Complete with Pesticide Record"
              (click)="showTaskHoursDialog(true, true)"
              severity="success" 
              class="editButtonMargin"
              >
            </p-button>
          }
          @if (canComplete
            && (workOrderWellnessTask.wellnessTask.goBackBucketId != undefined)
            && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
            && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
            <p-button
              type="button"
              label="Complete without Pesticide Record"
              (click)="showTaskHoursDialog(false, true)"
              severity="warn"
              >
            </p-button>
          }
          @if (canUndo) {
            <p-button type="button" label="Undo Complete" icon="fa fa-undo" (click)="undoComplete()" severity="info"></p-button>
          }
          <div>
            @if (canComplete
              && workOrderWellnessTask.wellnessTask.scheduleDateFrom
              && workOrderWellnessTask.wellnessTask.currentBigDaySubrangeId
              && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
              && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
              <p-button
                type="button"
                label="Multiday - Add Hours for Day"
                (click)="showTaskHoursDialogAddHours()"
                class="editButtonMargin"
              ></p-button>
            }
            @if (canComplete
              && (workOrderWellnessTask.wellnessTask.goBackBucketId != undefined)
              && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
              && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
              <p-button
                severity="danger"
                type="button"
                label="Unable to Complete"
                (click)="showTaskHoursDialogUnableToComplete(true)"
                class="editButtonMargin"
              ></p-button>
            }
          </div>
        </div>
      </div>
    }
    <div class="col-9" style="text-align: left">
      <h6>{{workOrderWellnessTask.wellnessTask?.name}} - GDD {{workOrderWellnessTask.wellnessTask?.growingDegreeDay}}</h6>
      <h6>
        @if (canSeeHiddenPrice || !hidePrice) {
          <span>{{workOrderWellnessTask.wellnessTask.price | currency}}</span>
        }
        @if ((canSeeHiddenPrice || !hidePrice) && !isCustomer) {
          <span> - </span>
        }
        @if (!isCustomer) {
          <span>{{workOrderWellnessTask.wellnessTask.hours}} hr(s)</span>
        }
      </h6>
    </div>
    @if (fromQuote && workOrderWellnessTask.id) {
      <div class="col-3" style="text-align: right">
        <p-checkbox name="agree" [disabled]="true" [(ngModel)]="isSelected" (onChange)="workCheckChanged($event)" binary="true"></p-checkbox>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-9" style="text-align: left">
      <h6 class="showLineBreaks">
        {{workOrderWellnessTask.wellnessTask?.description}}
      </h6>
    </div>
    <div class="col-3" style="text-align: right">
      @if (isEditable ) {
        <p-button
          type="button"
          icon="pi pi-copy"
          (click)="copyTask()"
          severity="secondary" 
          class="editMargin">
        </p-button>
      }
      @if (isEditable || canSetGoBack || (canEditAssignedTasks && scheduledBucket)) {
        <p-button type="button" icon="pi pi-pencil" (click)="editWellnessTask()"
          severity="secondary" class="editMargin">
        </p-button>
      }
      @if (isDeletable()) {
        <p-button type="button" icon="pi pi-trash" (click)="deleteWellnessTask()"
          severity="danger">
        </p-button>
      }
    </div>
  </div>
  <div class="row">
    @if (!workOrderWellnessTask.wellnessTask.isGoBack) {
      <div class="col-12" style="text-align: left">
        @if (canComplete
          && (workOrderWellnessTask.wellnessTask.currentBucketId != undefined || workOrderWellnessTask.wellnessTask.scheduleDateFrom)
          && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
          && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
          <p-button
            type="button"
            label="Complete with Pesticide Record"
            (click)="showTaskHoursDialog(true, false)"
            severity="success" 
            class="editButtonMargin"
            >
          </p-button>
        }
        @if (canComplete
          && (workOrderWellnessTask.wellnessTask.currentBucketId != undefined || workOrderWellnessTask.wellnessTask.scheduleDateFrom)
          && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
          && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
          <p-button
            type="button"
            label="Complete without Pesticide Record"
            (click)="showTaskHoursDialog(false, false)"
            severity="warn"
            >
          </p-button>
        }
        @if (canUndo && !showStatusBar) {
          <p-button type="button" label="Undo Complete" icon="fa fa-undo" (click)="undoComplete()" severity="info"></p-button>
        }
        <div>
          @if (canComplete
            && workOrderWellnessTask.wellnessTask.scheduleDateFrom
            && workOrderWellnessTask.wellnessTask.currentBigDaySubrangeId
            && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
            && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
            <p-button              
              type="button"
              label="Multiday - Add Hours for Day"
              (click)="showTaskHoursDialogAddHours()"
              class="editButtonMargin"
            ></p-button>
          }
          @if (canComplete
            && (workOrderWellnessTask.wellnessTask.currentBucketId != undefined || workOrderWellnessTask.wellnessTask.scheduleDateFrom)
            && workOrderWellnessTask.wellnessTask.completionStatus != 'Completed'
            && workOrderWellnessTask.wellnessTask.completionStatus !='Unable to be Completed') {
            <p-button              
              type="button"
              label="Unable to Complete"
              (click)="showTaskHoursDialogUnableToComplete(false)"
              class="editButtonMargin"
              severity="danger"
            ></p-button>
          }
        </div>
      </div>
    }
  </div>
  @if (workOrderWellnessTask.wellnessTask.wellnessTaskTreeTypes && workOrderWellnessTask.wellnessTask.wellnessTaskTreeTypes.length > 0) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Tree Type(s):
      </div>
      <div class="col-8">
        @for (wtTreeType of workOrderWellnessTask.wellnessTask.wellnessTaskTreeTypes; track wtTreeType) {
          <span class="taskStyle">
            {{wtTreeType.treeType.commonName}}
          </span>
        }
      </div>
    </div>
  }
  @if (workOrderWellnessTask.wellnessTask.location) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Location of Tree(s):
      </div>
      <div class="col-8">
        {{workOrderWellnessTask.wellnessTask.location}}
      </div>
    </div>
  }
  @if (uploadId > 0 && !isCustomer) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Uploads:
      </div>
      <div class="col-8">
        <app-blob-manager [angularUpload]="true"
          [containerName]="'wellness-task'"
          [parentRecordId]="uploadId"
          [uploadLabel]="'Document/Photo'"
        [viewOnly]="true"></app-blob-manager>
      </div>
    </div>
  }
  @if (workOrderWellnessTask.wellnessTask.wellnessTaskSkills && workOrderWellnessTask.wellnessTask.wellnessTaskSkills.length > 0 && !isCustomer) {
    <div class="row" style="text-align: left;">
      <div class="col-4">
        Required Skill(s):
      </div>
      <div class="col-8">
        @for (wtSkill of workOrderWellnessTask.wellnessTask.wellnessTaskSkills; track wtSkill) {
          <span class="taskStyle">
            {{wtSkill.skill.name}}
          </span>
        }
      </div>
    </div>
  }
  @if (workOrderWellnessTask.wellnessTask.wellnessTaskEquipment && workOrderWellnessTask.wellnessTask.wellnessTaskEquipment.length > 0 && !isCustomer) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Required Equipment Type(s):
      </div>
      <div class="col-8">
        @for (wtEquipment of workOrderWellnessTask.wellnessTask.wellnessTaskEquipment; track wtEquipment) {
          <span class="taskStyle">
            {{wtEquipment.equipmentType.type}}
          </span>
        }
      </div>
    </div>
  }

  @if (scheduledBucket && canSeePreviousCrew && !isCustomer) {
    <hr/>
  }
  @if (scheduledBucket && canSeePreviousCrew && !isCustomer) {
    <div class="row" style="text-align: left;">
      <div class="col-4">
        Work Date(s):
      </div>
      <div class="col-8">
        {{scheduledBucket.date | date: 'shortDate'}}@if (goBackScheduledBucket) {
        <span>, {{goBackScheduledBucket.date | date: 'shortDate'}}</span>
      }
    </div>
    <div class="col-4">
      Crew:
    </div>
    <div class="col-8">
      @for (sbEmployee of scheduledBucket.scheduledBucketEmployees; track sbEmployee) {
        <span class="taskStyle">
          {{sbEmployee.employee.fullName}}
        </span>
      }
      @for (sbEmployee of goBackScheduledBucket?.scheduledBucketEmployees; track sbEmployee) {
        <span class="taskStyle">
          {{sbEmployee.employee.fullName}}
        </span>
      }
    </div>
    <div class="col-4">
      Equipment:
    </div>
    <div class="col-8">
      @for (sbEquipment of scheduledBucket.scheduledBucketEquipment; track sbEquipment) {
        <span class="taskStyle">
          {{sbEquipment.equipment.number}}
        </span>
      }
      @for (sbEquipment of goBackScheduledBucket?.scheduledBucketEquipment; track sbEquipment) {
        <span class="taskStyle">
          {{sbEquipment.equipment.number}}
        </span>
      }
    </div>
  </div>
}

@if (workOrderWellnessTask.wellnessTask.taskHourEntries && workOrderWellnessTask.wellnessTask.taskHourEntries.length > 0 && canSeePreviousCrew && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Task Hours Total:
    </div>
    <div class="col-8">
      {{taskHourTotal | number: '1.0-2'}}
      @if ( canAdjustHours) {
        <p-button type="button" icon="pi pi-pencil" (click)="showTaskHoursDialog(false, false, true)"
          severity="secondary" class="editMargin">
        </p-button>
      }
    </div>
  </div>
}
@if (workOrderWellnessTask.wellnessTask.isGoBack && workOrderWellnessTask.wellnessTask.taskHourEntries && workOrderWellnessTask.wellnessTask.taskHourEntries.length > 0 && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Go Back Hours Total:
    </div>
    <div class="col-8">
      {{taskHourGoBackTotal | number: '1.0-2'}}
      <p-button type="button" icon="pi pi-pencil" (click)="showTaskHoursDialog(false, true, true)"
        severity="secondary" class="editMargin">
      </p-button>
    </div>
  </div>
}
@if (workOrderWellnessTask.wellnessTask.jobFeedback && canSeePreviousCrew && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Crew Feedback:
    </div>
    <div class="col-8">
      {{workOrderWellnessTask.wellnessTask.jobFeedback}}
    </div>
  </div>
}
@if (workOrderWellnessTask.wellnessTask.goBackFeedback && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Go Back Feedback:
    </div>
    <div class="col-8">
      {{workOrderWellnessTask.wellnessTask.goBackFeedback}}
    </div>
  </div>
}

@if (workOrderWellnessTask.wellnessTask.customerIssue && !isCustomer) {
  <hr/>
}
@if (workOrderWellnessTask.wellnessTask.customerIssue && !isCustomer) {
  <div class="row" style="text-align:left">
    <div class="col-4">
      Customer Issue:
    </div>
    <div class="col-8 showLineBreaks">
      {{workOrderWellnessTask.wellnessTask.customerIssue}}
    </div>
    <div class="col-4"></div>
    @if (workOrderWellnessTask.wellnessTask.goBackCompletionDate) {
      <div class="col-8">
        Resolved {{workOrderWellnessTask.wellnessTask.goBackCompletionDate | date: 'shortDate'}}
      </div>
    }
  </div>
}

@if (workOrderWellnessTask.wellnessTask.renewable && !workOrderWellnessTask.wellnessTask.renewed) {
  <hr/>
}
@if (workOrderWellnessTask.wellnessTask.renewable && !workOrderWellnessTask.wellnessTask.renewed) {
  <div class="row" style="text-align:left">
    <div class="col-4">
      Service Will Renew:
    </div>
    <div class="col-8 showLineBreaks">
      {{workOrderWellnessTask.wellnessTask.renewalAccepted ? 'Yes' : 'No'}} 
    </div>
  </div>
}
</p-card>

<p-dialog
  [modal]="true"
  [style]="{'width': '40em'}"
  (onHide)="closedTaskHoursDialog()"
  [(visible)]="showTaskHour"
  [draggable]="true"
  [blockScroll]="true"
  >
  @if (showTaskHour) {
    <app-task-hours-entry
      [asGoBack]="taskHoursForGoBack"
      [complete]="completeTask"
      [customerId]="customerId"
      [quoteNumber]="quoteNumber"
      [task]="workOrderWellnessTask.wellnessTask"
      [unableToComplete]="unableToComplete"
      [withRecord]="withRecord"
      [justUpdate]="justUpdateTaskHours"
      (addHours)="addedHours()"
      (commentId)="addCustomerCommentId($event)"
      (completed)="taskHoursCompleted()"
      (unableToCompleteSubmitted)="taskHoursSubmitted($event)"
      >
    </app-task-hours-entry>
  }
</p-dialog>